import HocHead from "@/Components/HigherOrderComponent/HocHead";
import Payment from "@/Components/pages/make-payment";
import MakePaymentSection from "@/Components/pages/make-payment/MakePaymentSection";
import React from "react";

const MakePayment: React.FC = () => {
  const seo = {
    metaTitle: "TRooTech - Your Partner From Alpha to Ultimate",
    metaDescription:
      "Pay at your convenience via multiple modes of payment including; cards, mobile wallets, and bank transfers.",
  };

  return (
    <>
      <HocHead seo={seo} />
      <Payment />
      <MakePaymentSection />
    </>
  );
};

export default MakePayment;
